import { Component, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { SisifoCenter, UsersService } from '@app/core/users';
import { Observable } from 'rxjs';
import { Centro } from '../models/center.type';

@Component({
  selector: 'app-center-select',
  templateUrl: './center-select.component.html',
  styleUrls: ['./center-select.component.css'],
})
export class CenterSelectComponent implements ControlValueAccessor {
  public selectedCenters: number[];
  public allCenters: SisifoCenter[];
  public defaultCenter: number | undefined;
  public center$: Observable<Array<SisifoCenter>>;

  public isDisabled: boolean;

  private onChange: (val: any) => any;
  private onTouch: () => any;

  constructor(
    @Self()
    @Optional()
    public control: NgControl,
    private service: UsersService
  ) {
    this.control && (this.control.valueAccessor = this);
    // map and order by label
    this.center$ = this.service.getSisifoAllCenters();
    this.center$.subscribe((centers) => {
      this.allCenters = centers;
    });
  }

  public get isInvalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  get selectedCentersObjects(): SisifoCenter[] {
    return this.allCenters?.filter((i) =>
      this.selectedCenters.includes(i.centroId)
    );
  }

  public get shouldShowError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;
    return this.isInvalid ? dirty || touched : false;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public writeValue(input: SisifoCenter[]): void {
    this.selectedCenters = input ? input.map((i) => i.centroId) : [];
    if (this.selectedCenters.length > 0) {
      console.log('selectedCenters', this.selectedCenters);
      if (!input.filter((i) => i.centroDefault)[0]?.centroId) {
        this.selectedCentersChanged();
      }
      this.defaultCenter = input.filter((i) => i.centroDefault)[0]?.centroId || this.selectedCenters[0]
    }
  }

  public selectedCentersChanged(): void {
    if (!this.onChange || !this.allCenters) {
      return;
    }
    // check if the default center value is no more in the selected centers
    if (
      this.defaultCenter &&
      !this.selectedCenters.includes(this.defaultCenter)
    ) {
      this.defaultCenter = this.selectedCenters[0];
    }
    const changeData = this.allCenters.filter((i) =>
      this.selectedCenters.includes(i.centroId)
    ).map((i) => {
      return {
        ...i,
        centroDefault: i.centroId === this.defaultCenter,
      };
    });
    this.onChange(changeData);
    this.onTouch();
  }
}
